module.exports = __webpack_public_path__ + "static/media/youliangxuanzhong@3x.53c9b1fe.png";